
import { numBlocks, displayBlocks } from '../services/payload_composition'
import { DefaultMap } from '../services/payload'
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    operation: {
      type: Object,
      required: true
    },
    mapType: {
      type: DefaultMap,
      required: true
    }
  },
  data() {
    return {
      srcTotalBlocks: 0,
      srcBlocks: '',
      dstTotalBlocks: 0,
      dstBlocks: ''
    }
  },
  mounted() {
    if (this.operation.srcExtents) {
      this.srcTotalBlocks = numBlocks(this.operation.srcExtents)
      this.srcBlocks = displayBlocks(this.operation.srcExtents)
    }
    if (this.operation.dstExtents) {
      this.dstTotalBlocks = numBlocks(this.operation.dstExtents)
      this.dstBlocks = displayBlocks(this.operation.dstExtents)
    }
  }
})
